/**
 * A function to create a log object for the 'dummyName' event (evid: 9500)
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params) {
    return { evid: 9500, src: 5, endpoint: 'post-login', params: params };
}
/**
 * A function to create a log object for the 'postLoginConfirmAccountDetails' event (evid: 9501)
 *
 * Event description: The buttons the user clicked on the "confirm account details" pop-up
 *
 * @param {postLoginConfirmAccountDetailsParams} params - The parameters for this event
 * @property {string} flowType - flow_type
 * @property {GUID} user_id - uuid
 * @property {string} button - button
 * @return {LogObject<postLoginConfirmAccountDetailsParams>} LogObject<postLoginConfirmAccountDetailsParams>
 */
export function postLoginConfirmAccountDetails(params) {
    return { evid: 9501, src: 5, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'postLoginChangeDetailsClickedContinue' event (evid: 9502)
 *
 * Event description: The user clicked "Continue" on the "Change your account email" pop up, this event includes the errors the user gets
 *
 * @param {postLoginChangeDetailsClickedContinueParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} methodType - method_type
 * @property {string} error_info - error_info
 * @return {LogObject<postLoginChangeDetailsClickedContinueParams>} LogObject<postLoginChangeDetailsClickedContinueParams>
 */
export function postLoginChangeDetailsClickedContinue(params) {
    return { evid: 9502, src: 5, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'postLoginResendCode' event (evid: 9503)
 *
 * Event description: The user clicked on "resend code"
 *
 * @param {postLoginResendCodeParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} methodType - method_type
 * @property {string} flow_type - flow_type
 * @return {LogObject<postLoginResendCodeParams>} LogObject<postLoginResendCodeParams>
 */
export function postLoginResendCode(params) {
    return { evid: 9503, src: 5, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'postLoginVerifyDetails' event (evid: 9504)
 *
 * Event description: The user clicked on "Verify"
 *
 * @param {postLoginVerifyDetailsParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} methodType - method_type
 * @property {string} error_info - error_info
 * @property {string} flow_type - flow_type
 * @return {LogObject<postLoginVerifyDetailsParams>} LogObject<postLoginVerifyDetailsParams>
 */
export function postLoginVerifyDetails(params) {
    return { evid: 9504, src: 5, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'postLoginConfirmDetailsDone' event (evid: 9505)
 *
 * Event description: The user clicked on the "Done" button in the "Confirm details" flow
 *
 * @param {postLoginConfirmDetailsDoneParams} params - The parameters for this event
 * @property {string} changes - changes
 * @property {GUID} user_id - uuid
 * @return {LogObject<postLoginConfirmDetailsDoneParams>} LogObject<postLoginConfirmDetailsDoneParams>
 */
export function postLoginConfirmDetailsDone(params) {
    return { evid: 9505, src: 5, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'postLoginRecoveryPhoneDetails' event (evid: 9506)
 *
 * Event description: The buttons the user clicked on the "Confirm recovery phone number" pop-up
 *
 * @param {postLoginRecoveryPhoneDetailsParams} params - The parameters for this event
 * @property {GUID} user_id - uuid
 * @property {string} phone_type - phone_type
 * @property {string} button - button
 * @property {string} error_info - error_info
 * @return {LogObject<postLoginRecoveryPhoneDetailsParams>} LogObject<postLoginRecoveryPhoneDetailsParams>
 */
export function postLoginRecoveryPhoneDetails(params) {
    return { evid: 9506, src: 5, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'postLoginMfaDetails' event (evid: 9507)
 *
 * Event description: The buttons the user clicked on the "2-step verification" pop-up
 *
 * @param {postLoginMfaDetailsParams} params - The parameters for this event
 * @property {GUID} user_id - uuid
 * @property {string} phone_type - phone_type
 * @property {string} button - button
 * @property {string} mfa_type - mfa_type
 * @property {string} error_info - error_info
 * @property {string} type - type
 * @return {LogObject<postLoginMfaDetailsParams>} LogObject<postLoginMfaDetailsParams>
 */
export function postLoginMfaDetails(params) {
    return { evid: 9507, src: 5, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'postLoginChangeYourPasswordDetails' event (evid: 9508)
 *
 * Event description: The buttons the user clicked on the "Change your password" pop-up
 *
 * @param {postLoginChangeYourPasswordDetailsParams} params - The parameters for this event
 * @property {GUID} user_id - uuid
 * @property {string} button - button
 * @property {string} error_info - error_info
 * @property {string} flow_type - flow_type
 * @return {LogObject<postLoginChangeYourPasswordDetailsParams>} LogObject<postLoginChangeYourPasswordDetailsParams>
 */
export function postLoginChangeYourPasswordDetails(params) {
    return { evid: 9508, src: 5, endpoint: '', params: params };
}
//# sourceMappingURL=index.js.map